import { createStore } from 'vuex'

const PRICE_TABLE_STORAGE_KEY = 'selected-price-table-id'

const loadSelectedPriceTableId = () => {
  if (typeof window === 'undefined') return null

  const rawValue = localStorage.getItem(PRICE_TABLE_STORAGE_KEY)
  if (rawValue === null || rawValue === undefined || rawValue === '') return null

  const parsedValue = Number(rawValue)
  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null
}

export default createStore({
  state: {
    logged: false,
    user: null,
    errorObject: null,
    successObject: null,
    badges: {},
    formState: {},
    selectedPriceTableId: loadSelectedPriceTableId(),
  },

  getters: {},

  mutations: {
    setLogged(state, statusLogged) {
      state.logged = statusLogged
    },
    setUser(state, user) {
      state.user = user
    },

    setError(state, object) {
      state.errorObject = object
    },
    setSuccess(state, object) {
      state.successObject = object
    },
    setFormState(state, object) {
      state.formState = object
    },
    setBadges(state, object) {
      state.badges = object
    },
    setSelectedPriceTableId(state, value) {
      const parsedValue = value === null || value === undefined || value === '' ? null : Number(value)
      state.selectedPriceTableId = Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null

      if (typeof window !== 'undefined') {
        if (state.selectedPriceTableId === null) {
          localStorage.removeItem(PRICE_TABLE_STORAGE_KEY)
        } else {
          localStorage.setItem(PRICE_TABLE_STORAGE_KEY, String(state.selectedPriceTableId))
        }
      }
    },
  },

  actions: {
    setLogged({ commit }, statusLogged) {
      commit('setLogged', statusLogged)
    },
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    setError({ commit }, object) {
      commit('setError', object)
    },
    setSuccess({ commit }, object) {
      commit('setSuccess', object)
    },
    setToastMessage({ commit }, object) {
      commit('setSuccess', object)
    },
    setForm({ commit }, object) {
      commit('setFormState', object)
    },
    setBadges({ commit }, object) {
      commit('setBadges', object)
    },
    setSelectedPriceTableId({ commit }, value) {
      commit('setSelectedPriceTableId', value)
    },
  },

  modules: {},
})
